import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import NewUser from './inner/NewUser.vue';
import PassRemind from './inner/PassRemind.vue';
import { SBMailAuthenticationResponse } from '@/components/SBMailAuthentication';
import SBAPI from '@/util/SBAPI';


@Component({
    components: AllComponents(),
})
export default class SignUp extends Mixins(CommonView) {

    type: "signup" | "reminder" = "signup";
    mailAuthentication: SBMailAuthenticationResponse | null = null;

    public async created() {
        if (this.$route.path === '/mypage/reminder') {
            this.type = "reminder";
        }
    }

    public reminder(val: SBMailAuthenticationResponse) {
        this.mailAuthentication = val;
        this.type = "reminder";
    }

    public signup(val: SBMailAuthenticationResponse) {
        this.mailAuthentication = val;
        this.type = "signup";
    }
}

